import useTranslation from '../../../Hooks/useTranslation';

export function useValidationMessage(prefix: string) {
	const { t } = useTranslation();

	const getMessageByKey = (key: string) => {
		return t(`${prefix}.${key}`) ?? '';
	};

	return { getMessageByKey };
}
